var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Directory extends Component {
    constructor() {
        super('Directory', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.module-directory .filter').on('change', (event, button) => {
                event.preventDefault();
                this.filterOffers();
            });
            $('.module-directory .btn-print').on('click', (event, button) => {
                event.preventDefault();
                window.print();
            });
            this.success();
        });
    }
    filterOffers() {
        const canton = $('.module-directory .filter-canton').val();
        const price = $('.module-directory .filter-price').val();
        const offers = $('.module-directory .offer');
        offers.each((offer) => {
            const offerCantons = offer.data('canton').split(',').map((canton) => canton.trim());
            const offerPrices = offer.data('price').split(',').map((price) => price.trim());
            if ((canton === 'all' || offerCantons.includes(canton)) && (price === 'all' || offerPrices.includes(price))) {
                offer.removeClass('d-none');
            }
            else {
                offer.addClass('d-none');
            }
            $('.module-directory .result-count').text($('.module-directory .offer:not(.d-none)').length);
        });
    }
}
